module.exports = __webpack_public_path__ + "img/t1.1822569c.png";